import { createBrowserRouter, Navigate } from "react-router-dom";

import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { AdminUsersPage } from "@/pages/admin/AdminUsersPage";
import { OneCBasesAdminPage } from "@/pages/admin/OneCBasesAdminPage";
import { CashflowPage } from "@/pages/cashflow/CashflowPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { IntercompanyPage } from "@/pages/intercompany/IntercompanyPage";
import { InvoicePreviewPage } from "@/pages/invoices/InvoicePreviewPage";
import { InvoicesPage } from "@/pages/invoices/InvoicesPage";
import { LoginPage } from "@/pages/LoginPage";
import { MarketplaceBuyoutPreviewPage } from "@/pages/marketplace-buyouts/MarketplaceBuyoutPreviewPage";
import { MarketplaceBuyoutsPage } from "@/pages/marketplace-buyouts/MarketplaceBuyoutsPage";
import { MarketplaceReportPreviewPage } from "@/pages/marketplace-reports/MarketplaceReportPreviewPage";
import { MarketplaceReportsPage } from "@/pages/marketplace-reports/MarketplaceReportsPage";
import { ProfilePage } from "@/pages/ProfilePage";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "profile", element: <ProfilePage /> },
      {
        path: "invoices",
        element: (
          <ProtectedRoute requirePermission="invoices">
            <InvoicesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "invoices/:id",
        element: (
          <ProtectedRoute requirePermission="invoices">
            <InvoicePreviewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "mp-reports",
        element: (
          <ProtectedRoute requirePermission="marketplace_reports">
            <MarketplaceReportsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "mp-reports/:id",
        element: (
          <ProtectedRoute requirePermission="marketplace_reports">
            <MarketplaceReportPreviewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "mp-buyouts",
        element: (
          <ProtectedRoute requirePermission="marketplace_buyouts">
            <MarketplaceBuyoutsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "mp-buyouts/:id",
        element: (
          <ProtectedRoute requirePermission="marketplace_buyouts">
            <MarketplaceBuyoutPreviewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "intercompany",
        element: (
          <ProtectedRoute requirePermission="intercompany_recon">
            <IntercompanyPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "cashflow",
        element: (
          <ProtectedRoute requirePermission="cashflow">
            <CashflowPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "admin/users",
        element: (
          <ProtectedRoute requireAdmin>
            <AdminUsersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "admin/onec-bases",
        element: (
          <ProtectedRoute requireAdmin>
            <OneCBasesAdminPage />
          </ProtectedRoute>
        ),
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
